import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { orpc } from "@/orpc/client";
import { ReferralLinkDetailPage } from "@/pages/app-detail/referral-links/detail/ReferralLinkDetailPage";
import { ReferralLinkDetailPageSkeleton } from "@/pages/app-detail/referral-links/detail/ReferralLinkDetailPageSkeleton";

const LinkDetailSearchSchema = z.object({
	tab: z.enum(["edit", "offer_codes"]).default("edit"),
});

export const Route = createFileRoute("/_app/apps/$appId/links/$linkId/")({
	validateSearch: LinkDetailSearchSchema,
	loader: async ({ context: { queryClient }, params }) =>
		queryClient.ensureQueryData(
			orpc.referralLinks.detail.queryOptions({ input: { id: params.linkId } }),
		),
	head: ({ loaderData: link }) => ({
		meta: [{ title: `Referral Link "${link?.slug ?? "Unknown"}" - Biteasy` }],
	}),
	pendingComponent: ReferralLinkDetailPageSkeleton,
	component: ReferralLinkDetailPage,
});
